export default __webpack_public_path__ + "static/media/app-logo-b.f059327d.svg";